import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {/* 
        Accessible live region wrapper for toast notifications
        Uses role="region" with aria-label for screen reader context
        Individual toasts use role="alert" for immediate announcement
      */}
      <div 
        aria-live="polite" 
        aria-atomic="true" 
        role="region"
        aria-label="Notifications"
      >
        {toasts.map(function ({ id, title, description, action, ...props }) {
          return (
            <Toast 
              key={id} 
              {...props} 
              role="alert"
              aria-describedby={description ? `toast-desc-${id}` : undefined}
              aria-labelledby={title ? `toast-title-${id}` : undefined}
            >
              <div className="grid gap-1">
                {title && <ToastTitle id={`toast-title-${id}`}>{title}</ToastTitle>}
                {description && (
                  <ToastDescription id={`toast-desc-${id}`}>{description}</ToastDescription>
                )}
              </div>
              {action}
              <ToastClose aria-label="Dismiss notification" />
            </Toast>
          )
        })}
      </div>
      <ToastViewport />
    </ToastProvider>
  )
}
